import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import {makeStyles} from "@material-ui/core";
import AssignmentIcon from '@material-ui/icons/Assignment';
import CommentIcon from '@material-ui/icons/Comment';
import PrintIcon from '@material-ui/icons/Print';
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {withRouter} from "react-router-dom";
import agreeData from "../../data/agreeData";
import surveyData from "../../data/surveyData";
import client from "../../lib/api/client";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    agreeDataState, answerState,
    menuDataState,
    selectedMenuItemState, stepState,
    surveyDataState,
    userState
} from "../../state/globalState";
import ReportPop from "./ReportPop";
import isLogin from "../../utils/isLogin";

const useStyles = makeStyles(theme => ({
    layout: {
        width: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            width: 700,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
    },
    nested: {
        paddingLeft: theme.spacing(4),
        height: 'fit-content',
        paddingTop: 10,
        paddingBottom: 10
    },
    selected: {
        color: 'green',
        background: 'red',
    },
    anchor: {
        textDecoration: 'none'
    },
    listItemText:{
        fontFamily: 'Noto Sans KR',
        fontStyle: 'normal',
        fontWeight: 100,
        color: '#000000',
        fontSize:'0.8rem',
    }
}));

const TreeMenu = ({ isTmpCont, history }) => {
    const userInfo = useRecoilValue(userState);
    const setAgreeData = useSetRecoilState(agreeDataState);
    const setSurveyData = useSetRecoilState(surveyDataState);
    const [menuData, setMenuData] = useRecoilState(menuDataState);
    const answer = useRecoilValue(answerState);
    const [selectedMenuItem, setSelectedMenuItem] = useRecoilState(selectedMenuItemState);
    const setStep = useSetRecoilState(stepState);
    const classes = useStyles();
    const dispatch = useDispatch();
    const {isLoadTempData} = useSelector(state => state.user);
    const [menuOpenAgree, setMenuOpenAgree] = React.useState(false);
    const [menuOpenSurvey, setMenuOpenSurvey] = React.useState(false);
    const [menuKeys, setMenuKeys] = React.useState([]);
    const [agreeMenu, setAgreeMenu] = React.useState([]);
    const [surveyMenu, setSurveyMenu] = React.useState([]);

    const [jrffile, setJrffile] = useState("");
    const [arg, setArg] = useState("");
    const [serviceapiurl, setServiceapiurl] = useState("");
    const [label, setLabel] = useState("");
    const [password, setPassword] = useState("");
    const [isSurvey, setIsSurvey] = React.useState("0");
    const [open, setOpen] = useState(false);

    useEffect(() => {

        // const CORPR = JSON.parse(localStorage.getItem("CORPR_BASE_INFO"));
        // if (userInfo && appStore.getState().agree.agree === null) {
            loadInitData(userInfo.corprInfoDiviNo);
        // }
        // dispatch(setCorprInfo(CORPR));
        isLogin().then((res) => {
            const { user, surveyYn } = res.payload;
            if (!user.admnNo) {
                window.location.replace("/");
                return;
            }

            setIsSurvey(surveyYn);
        });
    }, []);

    useEffect(() => {
        if (Object.keys(menuData).length > 0) {
            const tmpMenuKeys = Object.keys(menuData);
            tmpMenuKeys.map((item) => {
              // console.log(menuData[item]);
                if (menuData[item].treeTitle !== undefined) {
                    return {
                        ...item,
                        treeTitle: menuData[item].treeTitle.replace('$stdYear$', userInfo.stdYear)
                    };
                    // menuData[item].treeTitle = menuData[item].treeTitle.replace('$stdYear$', userInfo.stdYear);
                    // return item;
                }
            });
            setMenuKeys(tmpMenuKeys);
        }
    }, [menuData]);

    useEffect(() => {
        const tmpAgreeMenu = menuKeys.map((item) => (
            item.indexOf('AGREE_0') !== -1  ? (
                <ListItem key={item} button className={classes.nested} selected={item === selectedMenuItem}
                          onClick={() => handleListItemClick(item)}>
                    {(answer.tosaAgreeYn === "1" && answer.dpcnAgreeYn === "1" && answer.requiredAgreeYn &&
                        answer.kdpcUniIdentAgreeYn === "1" && answer.kdpcSstiIntoAgreeYn === "1" &&
                        answer.kdpcOtherAgreeYn === "1" && answer.dptyYn === "1") ? <CheckBoxIcon style={{paddingRight: 5, color: '#1b6817'}}/>
                        : <CheckBoxOutlineBlankIcon style={{paddingRight: 5}}/>}
                    <ListItemText classes={{primary:classes.listItemText}} primary={menuData[item].title} />
                </ListItem>
            ) : ''
        ));
        setAgreeMenu(tmpAgreeMenu);

        const tmpSurveyMenu = menuKeys.map((item) => {
            if(item.indexOf('SURVEY_') !== -1  && menuData[item]?.hasOwnProperty('hide')){
                if(!menuData[item].hide){
                    return  <ListItem key={item} button className={classes.nested} selected={item === selectedMenuItem}
                                      onClick={() => handleListItemClick(item)}>
                        {(menuData[item].column && answer[menuData[item].column]) ? <CheckBoxIcon style={{paddingRight: 5, color: '#1b6817'}}/> : <CheckBoxOutlineBlankIcon style={{paddingRight: 5}}/>}
                        <ListItemText classes={{primary:classes.listItemText}} primary={menuData[item].treeTitle} />
                    </ListItem>
                }
            }
           return ''
        });
        setSurveyMenu(tmpSurveyMenu);
    }, [menuKeys, answer.fileUrl]);

    const handleListItemClick = (val) => {
        const newStep = val.replace(/[^0-9]/g, '');

        setStep(newStep);

        // window.localStorage.setItem("previousLocation", window.location.pathname);
        if (val.indexOf('SURVEY') > -1) {
            setStep(newStep);

        } else {
            setSelectedMenuItem('AGREE_' + val.replace(/[^0-9]/g, ''));
            history.push('/agree/#' + val.replace(/[^0-9]/g, ''));
            return;
        }
        setSelectedMenuItem(val);
        // console.log('move : ', '/' + val.replace(/[0-9_]/g, '').toLowerCase() + '#' + val.replace(/[^0-9]/g, ''));

        history.push('/' + val.replace(/[0-9_]/g, '').toLowerCase() + '#' + val.replace(/[^0-9]/g, ''));
        // if (localStorage.getItem("previousLocation").indexOf('survey') > -1) {
        //     window.location.href = '/' + val.replace(/[0-9_]/g, '').toLowerCase() + '#' + val.replace(/[^0-9]/g, '');
        // } else {
        //     history.push('/' + val.replace(/[0-9_]/g, '').toLowerCase() + '#' + val.replace(/[^0-9]/g, ''));
        // }
    };

    const handleAgreeMenuClick = () => {
        setMenuOpenAgree(!menuOpenAgree);
    };

    const handleSurveyMenuClick = () => {
        setMenuOpenSurvey(!menuOpenSurvey);
    };

    // 1:1문의 게시판
    const handleMenuItemClick = (type) => {
        setSelectedMenuItem(type);
        if (type === "BOARD") {
            history.push("/questions");
        } else if (type === "SUMMARY") {
            history.push("/result");
        }  else if (type === "RESULT") {
            history.push("/result-mail");
        } else if (type === "DEC") {
            client.get('/kognr/getDecReportParams', {
                params: {
                    stdYear: userInfo.stdYear,
                    corprInfoDiviNo: userInfo.corprInfoDiviNo,
                    admnNo: userInfo.admnNo
                }
            }).then(response => {
                const {JrfFile, arg, serviceApiUrl} = response.data.payload;
                setJrffile(JrfFile);
                setArg(arg);
                setServiceapiurl(serviceApiUrl); // process.env.PUBLIC_RPT_URL 해당값 안넘어옴
                setLabel("종합소득세 신고서");
                setOpen(true);

            }).catch((error) => {
                console.log(error);
            });

        } else if (type === "TEQ") {
            client.get('/kognr/getTEQReportParams', {
                params: {
                    stdYear: userInfo.stdYear,
                    corprInfoDiviNo: userInfo.corprInfoDiviNo,
                    admnNo: userInfo.admnNo
                }
            }).then(response => {
                const {JrfFile, arg, serviceApiUrl} = response.data.payload;
                setJrffile(JrfFile);
                setArg(arg);
                setServiceapiurl(serviceApiUrl); // process.env.PUBLIC_RPT_URL 해당값 안넘어옴
                setLabel("본인부담세액 계산내역");
                setOpen(true);

            }).catch((error) => {
                console.log(error);
            });


            // const {stdYear, userAdmnDiviNo, corprInfoDiviNo} = userInfo;
            // const params = {
            //     title: "출력",
            //     jrf_folder: "tax/fy2021",
            //     jrf: "k_organizer_TEQ.jrf",
            //     arg: `std_year,${stdYear},user_admn_divi_no,${userAdmnDiviNo},rept_divi,HC017005,corpr_info_divi_no,${corprInfoDiviNo}`
            // };
            //
            // printReport(params);
        }
    };

    const printReport = (params) => {
        const _width = '1200';
        const _height = '900';
        const _left = Math.ceil(( window.screen.width - _width )/2);
        const _top = '100';
        const options = 'width=' + _width +', height='+ _height + ', left=' + _left + ', top='+ _top;

        const form = document.createElement("form");
        form.setAttribute("method", "post");
        form.setAttribute("action", "https://iit.eyhy.co.kr/kognrTEQ_report.jsp");
        form.setAttribute("target", "report_form");

        let input = document.createElement('input');
        input.type = 'hidden';
        input.name = "title";
        // input.value = aes128Encode(aes128SecretKey, aes128Iv, params["title"]);
        // input.value = params["title"];
        form.appendChild(input);

        input = document.createElement('input');
        input.type = 'hidden';
        input.name = "jrf_folder";
        // input.value = aes128Encode(aes128SecretKey, aes128Iv, params["jrf_folder"]);
        // input.value = params["jrf_folder"];
        form.appendChild(input);

        input = document.createElement('input');
        input.type = 'hidden';
        input.name = "jrf";
        // input.value = aes128Encode(aes128SecretKey, aes128Iv, params["jrf"]);
        // input.value = params["jrf"];
        form.appendChild(input);

        input = document.createElement('input');
        input.type = 'hidden';
        input.name = "arg";
        // input.value = aes128Encode(aes128SecretKey, aes128Iv, params["arg"].replace(/,/g, "#"));
        // input.value = params["arg"];
        form.appendChild(input);

        document.body.appendChild(form);

        if( /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) ){
            window.open("https://iit.eyhy.co.kr/kognrTEQ_report.jsp", "report_form", options);
        }else{
            window.open("https://iit.eyhy.co.kr/kognrTEQ_report.jsp", "report_form", options);
        }

        form.submit();

        document.body.removeChild(form);
    }

    function getURLParams(url) {
        var result = {};
        url.replace(/[?&]{1}([^=&#]+)=([^&#]*)/g, function(s, k, v) { result[k] = decodeURIComponent(v); });
        return result;
    }

    function loadInitData(corprInfoDiviNo) {
        try {
            setAgreeData(agreeData);
            setSurveyData(surveyData);
            // dispatch(setAgreeData(agreeData));
            // dispatch(setSurveyData(surveyData));

            const agreeTitle = agreeData.map((item) => ({
                title: item.title,
                isChecked: false
            }));

            let surveyTitle = surveyData.map((item, index) => {
                if (!["title", 2, 3, 4, 5 ].includes(item.type) && item.treeTitle !== "" && item.treeTitle !== undefined) {
                    return {
                        treeTitle: item.treeTitle,
                        hide: item.hide,
                        isChecked: false,
                        column: item.column || ""
                    };
                } else {
                    return {
                        treeTitle: item.title,
                        hide: undefined,
                        isChecked: false,
                        column: ""
                    }
                }
            });

            // surveyTitle.push({
            //     treeTitle: surveyData[117].treeTitle,
            //     hide: surveyData[117].hide,
            //     isChecked: false,
            //     column: surveyData[117].column || ""
            // });
            surveyTitle.push({
                treeTitle: surveyData[118].treeTitle,
                hide: surveyData[118].hide,
                isChecked: false,
                column: surveyData[118].column || ""
            });

            let menu = {};
            agreeTitle.forEach((value, key) => {
                menu['AGREE_' + key] = value;
            });
            // console.log("MENU >> ", menu);

            surveyTitle.forEach((value, key) => {
                if (corprInfoDiviNo === '2235') {
                    if (key !== 10 && key !== 12 && key !== 15 && key !== 29) {
                        menu['SURVEY_' + key] = value;
                    }
                } else {
                    menu['SURVEY_' + key] = value;
                }
            });

            Object.keys(menu).forEach((key) => {
                if (key.indexOf('SURVEY') !== -1 && menu[key].hide === undefined) {
                    delete menu[key];
                }
            });

            setMenuData(menu);
            // const user = localStorage.getItem('user');
            // if (!user) return;
            //
            // dispatch(tempSetUser(user));
            // dispatch(check());
        } catch (e) {
            console.log('localStorage is not working');
        }
    }

    return (
        (agreeMenu && surveyMenu && userInfo.surveyYn === "0") ? (<>
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                className={classes.root}
            >
                <ListItem button key='list_agree' onClick={handleAgreeMenuClick}>
                    <ListItemIcon>
                        <AssignmentIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="동의서" />
                    {menuOpenAgree ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={menuOpenAgree} timeout="auto" unmountOnExit>
                    <List component="div">
                        {agreeMenu}
                    </List>
                </Collapse>
                <ListItem button key='list_survey' onClick={handleSurveyMenuClick}>
                    <ListItemIcon>
                        <AssignmentIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="질문내용" />
                    {menuOpenSurvey ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={menuOpenSurvey} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {surveyMenu}
                    </List>
                </Collapse>
                {/*<ListItem button key='list_summary' onClick={() => handleMenuItemClick("SUMMARY")}>*/}
                {/*    <ListItemIcon>*/}
                {/*        <AssignmentIcon fontSize="small" />*/}
                {/*    </ListItemIcon>*/}
                {/*    <ListItemText primary="요약" />*/}
                {/*</ListItem>*/}
                <ListItem button key='list_question' onClick={() => handleMenuItemClick("BOARD")} selected={selectedMenuItem === "BOARD"}>
                    <ListItemIcon>
                        <CommentIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="1:1문의" />
                </ListItem>
            </List>
        </>) : (
            (<>
                <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    className={classes.root}
                >
                    {isSurvey === "0" ?
                        <ListItem button key='list_summary' onClick={() => handleMenuItemClick("SUMMARY")} selected={selectedMenuItem === "SUMMARY"}>
                            <ListItemIcon>
                                <AssignmentIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="요약" />
                        </ListItem> :
                        <ListItem button key='list_summary' onClick={() => handleMenuItemClick("RESULT")} selected={selectedMenuItem === "RESULT"}>
                            <ListItemIcon>
                                <AssignmentIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="질문지 제출 내용" />
                        </ListItem>
                    }
                    <ListItem button key='list_question' onClick={() => handleMenuItemClick("BOARD")} selected={selectedMenuItem === "BOARD"}>
                        <ListItemIcon>
                            <CommentIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="1:1문의" />
                    </ListItem>
                    {userInfo.citOpenYn === "1" && (
                        <ListItem button key='list_declaration' onClick={() => handleMenuItemClick("DEC")} selected={selectedMenuItem === "DEC"}>
                            <ListItemIcon>
                                <PrintIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="EY종합소득세 신고서" />
                        </ListItem>
                    )}
                    {userInfo.teqOpenYn === "1" && (
                        <ListItem button key='list_teq' onClick={() => handleMenuItemClick("TEQ")} selected={selectedMenuItem === "TEQ"}>
                            <ListItemIcon>
                                <PrintIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="EY 본인부담세액 계산내역" />
                        </ListItem>
                    )}
                    {
                        open && (
                            <ReportPop
                                jrffile={`${jrffile}`}
                                arg={arg}
                                serviceapiurl={serviceapiurl}
                                password={password}
                                label={label}
                                admnNm={userInfo.userNm}
                                setOpen={setOpen}
                                // excelFileNm={excelFileNm}
                                // arg="stdYear#2022#admnNo#202222300007#reptGcd#HC017001#taxOfficeSeq##gb#A"
                                // serviceapiurl="http://127.0.0.1:3001/api/cit/ty2022/rptMng/reportPasCitS175"
                            />
                        )
                    }
                </List>
            </>)
        )
    )
};

export default withRouter(TreeMenu);
